import { Box, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { DRAWER_WIDTH } from '../../shared/constants';

function Content({ title, children }) {
  return (
    <Box
      sx={{
        ml: { sm: 4, xs: 2 },
        mt: 5,
        mr: { sm: 4, xs: 2 },
        mb: 5,
        width: { sm: `calc(100% - ${DRAWER_WIDTH}px - 64px)`, xs: '100%' },
        height: '100%',
        // paddingRight: '32px',
      }}>
      <Toolbar />
      {title && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="title">{title}</Typography>
        </Box>
      )}
      {children}
    </Box>
  );
}

export default Content;
